<template>
	<DjBox class="pt-5 md:pt-8 px-5 md:px-10 pb-5 md:pb-10">
		<h3 class="text-lg md:text-xl font-medium mb-4">{{ title }}</h3>
		<div class="flex flex-wrap gap-[10px]">
			<a v-if="socials && socials.facebook" :href="socials.facebook" target="_blank">
				<BaseIcon
					class="cursor-pointer text-[30px] md:text-[50px]"
					icon="entypo-social:facebook-with-circle"
					color="#0E89F0"
				/>
			</a>
			<a v-if="socials && socials.linkedin" :href="socials.linkedin" target="_blank">
				<BaseIcon
					class="cursor-pointer text-[30px] md:text-[50px]"
					icon="entypo-social:linkedin-with-circle"
					color="#0C66C2"
				/>
			</a>
			<a v-if="socials && socials.instagram" :href="socials.instagram" target="_blank">
				<div
					class="grid place-content-center w-dj-30 h-dj-30 md:w-dj-50 md:h-dj-50 bg-gradient-to-bl from-[#D33C7B] to-[#EA7D38] rounded-full cursor-pointer"
				>
					<BaseIcon class="text-base md:text-[24px]" icon="fa:instagram" color="white" />
				</div>
			</a>
			<a v-if="socials && socials.youtube" :href="socials.youtube" target="_blank">
				<div
					class="grid place-content-center w-dj-30 h-dj-30 md:w-dj-50 md:h-dj-50 bg-[#F23F3F] rounded-full cursor-pointer"
				>
					<BaseIcon class="text-xl md:text-[30px]" icon="fa:youtube" color="white" />
				</div>
			</a>
			<a v-if="socials && socials.web_address" :href="socials.web_address" target="_blank">
				<div
					class="grid place-content-center w-dj-30 h-dj-30 md:w-dj-50 md:h-dj-50 bg-dj-red rounded-full cursor-pointer"
				>
					<BaseIcon class="text-base md:text-[26px]" icon="fluent:globe-32-regular" color="white" />
				</div>
			</a>
			<a v-if="socials && socials.other" :href="socials.other" target="_blank">
				<div
					class="grid place-content-center w-dj-30 h-dj-30 md:w-dj-50 md:h-dj-50 bg-[#C42947] rounded-full cursor-pointer"
				>
					<BaseIcon class="text-base md:text-[26px]" icon="akar-icons:link-chain" color="white" />
				</div>
			</a>
		</div>
	</DjBox>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import DjBox from "~/ui-kit/components/box/DjBox.vue";
import BaseIcon from "~/ui-kit/components/BaseIcon.vue";

type Socials = {
	facebook?: string;
	linkedin?: string;
	instagram?: string;
	youtube?: string;
	web_address?: string;
	other?: string;
};

export default defineComponent({
	name: "DjBoxSocials",
	components: { DjBox, BaseIcon },
	props: {
		socials: {
			type: Object as PropType<Socials>,
		},
		title: {
			type: String,
		},
	},
});
</script>
